import { ReactElement } from 'react';
import ControlledCalendarDrawer from '@provider-directory/components/controlled-calendar-drawer';
import RangeDatePickerComponent from '@provider-directory/components/range-date-picker/range-date-picker.component';
import { ISearchCalendarProps } from '@provider-directory/hooks/useCalendar';

export const ProviderSearchCalendar = ({
  value,
  onChange,
  isDesktop,
  previousRange,
  setPreviousRange,
  timeZone,
  t: translate,
  locale,
  lastFetchableDate,
  todaysDate,
  isOpen,
  toggleOpen,
  setIsOpen,
  timeStampHandler,
}: Omit<
  ISearchCalendarProps,
  'setDisableNextButton' | 'setDisabledPrevButton'
>): ReactElement => {
  return (
    <>
      {isDesktop ? (
        <div
          className={
            'hidden justify-end desktop:visible desktop:col-span-4 desktop:flex desktop:h-fit'
          }
        >
          <RangeDatePickerComponent
            className={'rounded-t-[16px] border-none bg-white p-6 outline-none'}
            valueRange={value}
            isOpen={isOpen}
            toggleOpen={toggleOpen}
            setIsOpen={setIsOpen}
            timeZone={timeZone}
            onChangeRange={onChange}
            todaysDate={todaysDate}
            lastFetchableDate={lastFetchableDate}
            setPreviousRange={setPreviousRange}
            previousRange={previousRange}
            cancelCta={translate('search.cancel')}
            applyCta={translate('search.apply')}
            locale={locale}
          />
        </div>
      ) : (
        <ControlledCalendarDrawer
          timeStampHandler={timeStampHandler}
          value={value}
          isOpen={isOpen}
          toggleOpen={toggleOpen}
          setIsOpen={setIsOpen}
          onChange={onChange}
          timeZone={timeZone}
          todaysDate={todaysDate}
          lastFetchableDate={lastFetchableDate}
          previousRange={previousRange}
          cancelCta={translate('search.cancel')}
          applyCta={translate('search.apply')}
          locale={locale}
          t={translate}
        />
      )}
    </>
  );
};
